import(/* webpackMode: "eager" */ "/app/src/app/dich-vu-mo-rong/[post]/page.js");
